import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKeuken = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M8 17h24v14H8z"
    />
    <path
      stroke="#00C5F2"
      strokeWidth={2}
      d="M15 12.357C15 10.227 16.343 9 18 9s3 1.227 3 3.357V17.5"
    />
    <path
      fill="#00C5F2"
      d="M15 16h10v2H15zM10 19h9v10h-9zM21 19h9v10h-9z"
    />
    <circle
      cx={23}
      cy={24}
      r={1}
      fill="#85E3F9"
    />
    <circle
      cx={17}
      cy={24}
      r={1}
      fill="#85E3F9"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKeuken);

export default ForwardRef;
